// extracted by mini-css-extract-plugin
export default {"audioVisualizer":"AudioVisualizer_audioVisualizer__isJkf"};